import React from 'react';
import { Button, Container, Stack, Table, Typography } from '@mui/joy';
import { useLoaderData, useNavigate } from 'react-router';
import { CourseSummary } from '../models/course';

interface CourseListLoaderData {
    courses: CourseSummary[];
}

const CourseList = () => {
    const { courses } = useLoaderData() as CourseListLoaderData;
    const navigate = useNavigate();

    return (
        <Container>
        <Stack spacing={3}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography level="h2">Courses</Typography>
                <Button onClick={() => navigate('/courses/new')}>New Course</Button>
            </Stack>

            {courses.length === 0 ? (
                <Typography>No courses yet.</Typography>
            ) : (
                <Table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Holes</th>
                            <th>Par</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {courses.map((course) => (
                            <tr key={course.id}>
                                <td>{course.name}</td>
                                <td>{course.holeCount}</td>
                                <td>{course.totalPar}</td>
                                <td>
                                    <Button
                                        size="sm"
                                        variant="outlined"
                                        onClick={() => navigate(`/courses/${course.id}/edit`)}
                                    >
                                        Edit
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </Stack>
        </Container>
    );
};

export default CourseList;
